var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Layout',[_c('div',{staticClass:"container mt-4 mb-4"},[_c('div',{staticClass:"mb-2"},[_c('ShowPath',{attrs:{"path":[
          { title: 'Início', to: '/'},
          { title: 'Publicações oficiais'},
        ]}})],1),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"mb-2"},[_c('Title1',[_vm._v(" PUBLICAÇÕES OFICIAIS ")])],1)])]),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('ListCategoriaDocumentos')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }